import { render, staticRenderFns } from "./SpaceEditor.vue?vue&type=template&id=53abc88c&"
import script from "./SpaceEditor.vue?vue&type=script&lang=js&"
export * from "./SpaceEditor.vue?vue&type=script&lang=js&"
import style0 from "./SpaceEditor.vue?vue&type=style&index=0&id=53abc88c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports